import { render, staticRenderFns } from "./AnticorruptionPolicy.vue?vue&type=template&id=5a371872"
import script from "./AnticorruptionPolicy.vue?vue&type=script&lang=js"
export * from "./AnticorruptionPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports